import { CubeAddress } from "../address";

export enum Cube2COrderInstructionState {
  DRAFT = "DRAFT",
  WAIT_UPLOAD = "WAIT_UPLOAD",
  WAIT_SUMBIT = "WAIT_SUMBIT",
  WAIT_REPAIR = "WAIT_REPAIR",
  WAIT_PACK = "WAIT_PACK",
  PROCESSING = "PROCESSING",
  GENERATINGLABEL = "GENERATINGLABEL",
  CHARGEBACK_SUCCESS = "CHARGEBACK_SUCCESS",
  WAIT_DISTRIBUTION = "WAIT_DISTRIBUTION",
  PACKED = "PACKED",
  DELIVERED = "DELIVERED",
  DISTRIBUTION = "DISTRIBUTION",
  REFUNDED_SUCCESS = "REFUNDED_SUCCESS",
  REFUND_TIMEOUT_AMOUNT_REFUND = "REFUND_TIMEOUT_AMOUNT_REFUND",
  REFUND_TIMEOUT_NOT_REFUND = "REFUND_TIMEOUT_NOT_REFUND",
  APPLICATION = "APPLICATION",
  DISTRIBUTION_PACKING = "DISTRIBUTION_PACKING",
  PENDING_OUTBOUND = "PENDING_OUTBOUND",
}

export interface CubeInstructionQuery {
  notDraft?: boolean;
  instructionNumber?: string;
  theThirdNumber?: string;
  createStartDate?: string;
  createEndDate?: string;
  sortBy?: string;
  order?: "asc" | "desc";
  limit?: number;
  index?: number;
}

export type Cube2COrderQuery = CubeInstructionQuery;

export interface Cube2COrderInstruction {
  ageingTypes: string;
  channelCode: string;
  channelCodeTl: string;
  createBy: string;
  createById: string;
  createDate: string;
  currency: string;
  instructionNumber: string;
  instructionId: string;
  theThirdNumber: string;
  state: Cube2COrderInstructionState;
}

export interface Cube2COrderItem {
  brand: string;
  createDate: string;
  currency: string;
  enProductName: string;
  instructionQuantity: string;
  itemId: string;
  lastUpdated: string;
  packageId: string;
  productId: string;
  productName: string;
  productShelfCode: string;
  productShelfIds: string;
  productShelfQtys: string;
  quantity: string;
  totalPrice: string;
  unitPrice: string;
  upcBarcode: string;
  weight: number;
  weightUnit: string;
}

export interface Cube2COrderPackageListItem {
  itemList: Cube2COrderItem[];
}

export interface CubeUserInfo {
  userCode: string;
  userId: number;
}

export interface Cube2COrder {
  instruction: Cube2COrderInstruction;
  pushError: string;
  pushIsError: boolean;
  recipient: CubeAddress;
  sender: CubeAddress;
  packageList: Cube2COrderPackageListItem[];
  userInfo: CubeUserInfo;
}

export type Cube2COrderOutboundInstruction = Cube2COrder;

export enum DeliveryState {
  PENDING_OUTBOUND = "PENDING_OUTBOUND",
  START_DISTRIBUTION = "START_DISTRIBUTION",
  DISTRIBUTION_FINISH = "DISTRIBUTION_FINISH",
  PENDING_PALLET = "PENDING_PALLET",
  PENDING_CARTON_INFORMATION = "PENDING_CARTON_INFORMATION",
  PENDING_RDY_PARTY_UPLOAD = "PENDING_RDY_PARTY_UPLOAD",
  RDY_PARTY_PENDING_OUTBOUND = "RDY_PARTY_PENDING_OUTBOUND",
  PLAN_DELIVERY = "PLAN_DELIVERY",
  APPLICATION = "APPLICATION",
  APPLICATION_SUCCESS = "APPLICATION_SUCCESS",
  SUCCESSFUL_SIGNING = "SUCCESSFUL_SIGNING",
  COMPLETE_DELIVERY = "COMPLETE_DELIVERY",
  DRAFT = "DRAFT",
}

export interface Cube2BOrderQuery {
  customerNumber?: string;
  orderState?: DeliveryState;
  createStartDate?: string;
  createEndDate?: string;
  sendStartDate?: string;
  sendEndDate?: string;
  sortBy?: string;
  order?: "asc" | "desc";
  deliveryNos?: string[];
  limit?: number;
  index?: number;
}

export interface Cube2BOrder {
  amazonAppointment: string;
  amazonFreightNumber: string;
  amazonReferNumber: string;
  appDate: string;
  applyShipToNowDay: string;
  applyShippingDate: string;
  deliverNumber: string;
  bolPath: string;
  boxQuantity: string;
  boxStockDeliverId: string;
  userCode: string;

  //
  state: Cube2COrderInstructionState;
}
